import { useCallback, useEffect, useState } from "react";
import OrderInfo from "./OrderInfo";
import { useTranslation } from "react-i18next";
import { message, Form, Button, Modal, Divider, Checkbox, Flex } from "antd";
import { getUser } from "@/api/config";
import AuthOtherOrder from "@/components/Order/AuthOtherOrder";
import {
  OrderStore,
  mergeOrderListStore,
  mergeOrderSelectIdsStore,
} from "@/store/order";
import { useRecoilValue, useSetRecoilState } from "recoil";
import style from "./mobile.module.scss";
import { math } from "@/utils/math";
import { IS_MOBILE, toLogin } from "@/utils/tool";

type Props = {
  order: Order;
  step: number;
};

type TotalInfo = Pick<
  Order,
  | "total_money"
  | "exp_cny_pay_money"
  | "tax_money"
  | "commission_money"
  | "pay_methods"
  | "pay_status"
  | "order_id"
  | "configuration"
>;

const MobileStep1 = (props: Props) => {
  const { order, step } = props;
  const { t } = useTranslation();
  const user = getUser();
  const [showMerge, setShowMerge] = useState(false);
  const mergeOrderList = useRecoilValue(mergeOrderListStore);
  const mergeOrderSelectIds = useRecoilValue(mergeOrderSelectIdsStore);
  const setOrder = useSetRecoilState(OrderStore);
  const [moneyList, setMoneyList] = useState<Array<number>>();
  const [payUrl, setPayUrl] = useState("");
  const [payLoading, setPayLoading] = useState(false);
  const [modalInstance, setModalInstance] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [totalInfo, setTotalInfo] = useState<TotalInfo>({
    total_money: order.total_money,
    exp_cny_pay_money: order.exp_cny_pay_money,
    tax_money: order.tax_money,
    commission_money: order.commission_money,
    pay_methods: order.pay_methods,
    pay_status: order.pay_status,
    order_id: order.order_id,
    configuration: order.configuration,
  });

  /**
   * 触发合并订单
   */
  const mergeOrder = (isMerge: boolean) => {
    if (!user) {
      toLogin();
      return;
    }
    setShowMerge(isMerge);
  };

  /**
   *
   * @param newOrder 拆分成功更新订单
   */
  const splitOrderSuccess = (newOrder) => {
    setOrder((order) => {
      return { ...order, ...newOrder };
    });
  };

  /**
   * 计算总金额
   */
  useEffect(() => {
    const ids = mergeOrderSelectIds.join(",");
    const selectOrders = ids
      ? mergeOrderList.filter((item) => ids.includes(item.order_id))
      : [];
    const moneyList = [order.total_money];
    const total = {
      total_money: order.total_money,
      exp_cny_pay_money: order.exp_cny_pay_money,
      tax_money: order.tax_money,
      commission_money: order.commission_money,
      pay_methods: order.pay_methods,
      pay_status: order.pay_status,
      order_id: order.order_id,
      configuration: order.configuration,
    };
    for (let i = 0; i < selectOrders.length; i++) {
      const element = selectOrders[i];
      const { total_money, exp_cny_pay_money, tax_money, commission_money } =
        element;
      total.total_money = math
        .add(math.bignumber(total.total_money), math.bignumber(total_money))
        .toNumber();
      total.exp_cny_pay_money = math
        .add(
          math.bignumber(total.exp_cny_pay_money),
          math.bignumber(exp_cny_pay_money)
        )
        .toNumber();
      total.tax_money = math
        .add(math.bignumber(total.tax_money), math.bignumber(tax_money))
        .toNumber();
      total.commission_money = math
        .add(
          math.bignumber(total.commission_money),
          math.bignumber(commission_money)
        )
        .toNumber();

      moneyList.push(element.total_money);
    }

    setTotalInfo({ ...total });
    setMoneyList(moneyList);
  }, [order, mergeOrderList, mergeOrderSelectIds]);

  return (
    <>
      {contextHolder}
      <div
        className={style.info}
        style={{ display: `${step === 0 ? "" : "none"}` }}
      >
        <div className={style.order_info_wrapper}>
          <Flex wrap="wrap" align="center" gap={8}>
            <span style={{ color: "inherit", marginRight: "0.666rem" }}>
              {t("订单号")}
            </span>
            <span style={{ wordBreak: "break-all" }}>
              {order.publishing_house_order_id}
            </span>
          </Flex>
          {order.pay_orders.length > 0 && (
            <span className={style.status}>{t("已拆分")}</span>
          )}
        </div>
        <OrderInfo order={order} splitOrderSuccess={splitOrderSuccess} />
        {order.configuration.enable_merge_order &&
          (showMerge ? (
            <AuthOtherOrder order={order} cancelMerge={mergeOrder} />
          ) : (
            order.pay_status !== 2 && (
              <Button
                className={style["merge-order-button"]}
                onClick={() => mergeOrder(true)}
                style={IS_MOBILE ? { background: "transparent" } : {}}
              >
                {t("合并支付其他订单")}
              </Button>
            )
          ))}
      </div>
      {/* {step == 0 && (
        <div className={style.fixed_bottom_area}>
          <Button
            className={style.bottom_btn}
            onClick={() => setStep(1)}
            type="primary"
          >
            {t("确认订单，下一步")}
          </Button>
        </div>
      )} */}
      {modalInstance}
    </>
  );
};

export default MobileStep1;
